/**
 * Build a short display ID for a work item.
 * Prefers `item_number` when present; falls back to the last 4 hex chars of the UUID
 * (uppercased) for backwards compatibility with older items that pre-date item_number.
 */
export const getDisplayId = (
  prefix: string,
  id: string,
  itemNumber?: number,
): string =>
  itemNumber !== undefined
    ? `${prefix}-${itemNumber}`
    : `${prefix}-${id.slice(-4).toUpperCase()}`;
